import React, { Component } from 'react';
import { Form, message, Modal } from 'antd';

import UploadFile from '@comm/upload/UploadFile';
import { queryImportFundsRecord } from '@api/finance/funds';

const FormItem = Form.Item;

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
    };
  }

  componentWillMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }

    const income = this.props.form.getFieldsValue();

    const obj = Object.assign(this.state.content, income);
    if (this.state.licenseFile && this.state.licenseFile.length > 0) {
      obj.fileUuid = this.state.licenseFile[0].uuid;
    }
    obj.bookUuid = this.props.uuid;
    const { handleSubmit } = this.props;
    this.props.form.validateFields(err => {
      if (!err) {
        queryImportFundsRecord(obj).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            handleSubmit(obj);
          } else if (res.statusCode === 250) {
            message.warn(res.message);
          } else {
            message.error(res.message);
          }
        });
      }
    });
  };

  handlelicenseFile = fileList => {
    this.setState({
      licenseFile: fileList,
    });
  };

  render() {
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const licenseFile = this.state.licenseFile || [];
    return (
      <Modal title="导入" visible onCancel={this.props.cancel} onOk={this.submit}>
        <Form layout="horizontal">
          <FormItem label="上传Excel文件" {...formItemLayout} required>
            <UploadFile
              type="ghost"
              handleUpload={this.handlelicenseFile}
              fileList={licenseFile}
              isExcel
            />
            <span className="ant-form-text">&nbsp;仅限excel格式</span>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(DetailModal);



// WEBPACK FOOTER //
// ./src/components/finance/funds/detail/ModalImportExcel.js